import React, { useState } from "react";
import "../styles/MembershipWithdrawal.css";
import MyPageSidebar from "./MyPageSidebar";

const MembershipWithdrawal = () => {
    const [reason, setReason] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [isChecked, setIsChecked] = useState(false);

    return (
        <div className="withdrawal-container">
            <MyPageSidebar />
            <div className="withdrawal-content">
                <h2 className="withdrawal-title">회원탈퇴</h2>
                <p className="withdrawal-subtitle">회원 탈퇴를 위해 개인 정보 확인이 필요합니다.</p>

                {/* ✅ 기본 정보 입력 */}
                <div className="withdrawal-section">
                    <label className="withdrawal-label">아이디</label>
                    <input type="text" className="withdrawal-input" value="000002zzzz" readOnly />
                </div>

                <div className="withdrawal-section">
                    <label className="withdrawal-label">이름</label>
                    <input type="text" className="withdrawal-input" value="" placeholder="이름을 입력하세요." />
                </div>

                <div className="withdrawal-section">
                    <label className="withdrawal-label">이메일</label>
                    <input type="text" className="withdrawal-input" value="" placeholder={"이메일을 입력하세요."} />
                </div>

                <div className="withdrawal-section">
                    <label className="withdrawal-label">전화번호</label>
                    <input type="text" className="withdrawal-input" value="" placeholder="전화번호를 입력하세요. (예: 010-1234-5678)"  />
                </div>

                <button className="withdrawal-confirm-btn">개인 정보 확인</button>

                {/* ✅ 탈퇴 안내사항 */}
                <div className="withdrawal-info">
                    <h3>회원탈퇴 시 안내사항을 확인해 주세요</h3>
                    <ul>
                        <li>탈퇴 시 온오프라인 포인트 적립/사용을 포함한 모든 소프트캣 서비스를 이용하실 수 없습니다.</li>
                        <br/>
                        <li>•개인정보 보유 및 이용 동의</li>
                        <li>가입 시 입력하신 회원 개인정보는 탈퇴 후 즉시 파기됩니다. 단, 법령에 의해 보유해야 하는 개인정보는 법정 의무 보유 기간까지 보유하며, 부정이용 방지를 위해 회원의 CI는 암호화하여 6개월 간 보관합니다. (이용 정지 회원의 경우 2년) 상세한 내용은 개인정보 처리 방침에서 확인하실 수 있습니다.</li>
                        <br/>
                        <li>•재가입 규정 및 제한 동의</li>
                        <li>탈퇴 후 재가입 시 신규 회원 가입으로 처리되며, 탈퇴 전의 회원 정보와 거래 정보는 복구되지 않습니다. 기존에 사용하셨던 아이디의 사용은 불가합니다. 이용 제한 중인 회원은 제한 해제일 이전 재가입할 수 없으며, 가입이 제한됩니다.</li>
                        <br/>
                        <li>•정기 주문 자동 해지 동의</li>
                        <li>탈퇴 시 모든 정기결제 상품이 자동으로 해지됩니다.</li>
                        <br/>
                        <li>•혜택 소멸 동의</li>
                        <li>보유 중인 소프트캣 포인트, 쿠폰은 탈퇴 즉시 소멸되며, 복구되지 않습니다.</li>
                        <br/>
                        <li>•작성 콘텐츠 및 리뷰 등 게시글 정책 동의</li>
                        <li>기존에 작성하신 콘텐츠와 리뷰 등의 게시글은 탈퇴 후에도 자동 삭제되지 않습니다. 작성하신 콘텐츠에 대한 삭제를 원하실 경우, 탈퇴 전 삭제를 진행해 주세요.</li>
                    </ul>
                    <label className="withdrawal-checkbox">
                        <input type="checkbox" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
                        <span>안내를 확인했으며, 동의합니다.</span>
                    </label>
                </div>

                {/* ✅ 탈퇴 사유 선택 */}
                <h3 className="withdrawal-reason-title">소프트캣을 떠나는 이유를 알고 싶습니다.</h3>
                <div className="withdrawal-reason-box"> {/* ✅ 배경 박스 추가 */}
                    <div className="withdrawal-reason">
                        {["텍스트 텍스트 텍스트 텍스트 텍스트1", "텍스트 텍스트 텍스트 텍스트 텍스트2", "텍스트 텍스트 텍스트 텍스트 텍스트3", "텍스트 텍스트 텍스트 텍스트 텍스트4"].map((item, index) => (
                            <label key={index} className="withdrawal-radio">
                                <input type="radio" name="reason" value={item} checked={reason === item} onChange={(e) => setReason(e.target.value)} />
                                {item}
                            </label>
                        ))}
                        {/* ✅ 기타 입력 필드 */}
                        <label className="withdrawal-radio">
                            <input type="radio" name="reason" value="기타" checked={reason === "기타"} onChange={(e) => setReason(e.target.value)} />
                            기타 (직접입력)
                        </label>
                        {reason === "기타" && (
                            <input type="text" className="withdrawal-other-input" placeholder="직접 입력하세요." value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                        )}
                    </div>
                </div>

                {/* ✅ 취소 & 탈퇴 버튼 */}
                <div className="withdrawal-actions">
                    <button className="withdrawal-cancel-btn">취소</button>
                    <button className="withdrawal-submit-btn">탈퇴하기</button>
                </div>
            </div>
        </div>
    );
};

export default MembershipWithdrawal;
